import { Location } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomInitialConsecutiveComponent } from 'src/app/components/custom-initial-consecutive/custom-initial-consecutive.component';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { TransferStoreWorkshopStateEnums } from 'src/app/enum/transfer-store-workshop-enum';
import { WindowEnums } from 'src/app/enum/window-enums';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { TransferStoreWorkshopModel } from 'src/app/models/maintenance/transfer-store-workshop.model';
import { TransferStoreWorkshopPrintModel } from 'src/app/models/print/maintenance/transfer-store-workshop-print.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { TransferStoreWorkshopService } from 'src/app/services/maintenance/transfer-store-workshop.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-register-transfer-store-workshop',
  templateUrl: './register-transfer-store-workshop.component.html',
  styleUrls: ['./register-transfer-store-workshop.component.scss'],
  standalone: false
})
export class RegisterTransferStoreWorkshopComponent implements OnInit {

  @ViewChild('initialConsecutive') initialConsecutiveModalComponent?: CustomModalComponent | null = null;

  branchId: number = 0;
  companyId: number = 0;
  componentInitialConsecutiveModal = CustomInitialConsecutiveComponent;
  disabledForm: boolean = false;
  formTransferStoreWorkshop: FormGroup = new FormGroup({});
  hasQuantityInZero: boolean = false;
  icon: string = '';
  isOpened: string | undefined = undefined;
  listBranches: CustomListDropdown[] = [];
  listTypes: CustomListDropdown[] = [
    { label: 'Limpieza', value: 2 },
    { label: 'Reparación', value: 3 }
  ];
  listObservers: Array<Subscription> = new Array<Subscription>();
  nameWindow: string = 'Captura Traslado Almacén Taller';
  output$ = new Subject<any>();
  permissionPrint: boolean = false;
  permissionsUser: OptionWindowModel[] = [];
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  reloadPrint: boolean = false;
  severityState: string = 'success';
  stateTransferStoreWorkshop: string = '';
  subscription: Subscription;
  titleState: string = '';
  transferStoreWorkshopContract: TransferStoreWorkshopModel = new TransferStoreWorkshopModel();
  transferStoreWorkshopId: number = 0;
  transferStoreWorkshopPrintModel: TransferStoreWorkshopPrintModel = new TransferStoreWorkshopPrintModel();
  url: string = 'transfer-store-workshop'
  userAuthenticated: UserModel = new UserModel();

  constructor(
    private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private dateConverterService: DateConverterService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private location: Location,
    private optionWindowService: OptionWindowService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService,
    private transferStoreWorkshopService: TransferStoreWorkshopService) {
    this.validateForm(new TransferStoreWorkshopModel());
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.transferStoreWorkshopId = Object.keys(params).length > 0 ? params?.id : null;
    });

    this.subscription = this.output$.subscribe(async ({ type, payload }) => {
      if (type === 'initialConsecutive') {
        this.formTransferStoreWorkshop.patchValue({
          consecutive: payload.consecutive
        });
        await this.send();
      }
    });

    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async annulTransferStoreWorkshop() {
    if (!this.transferStoreWorkshopId) {
      return this.toastHandlerService.showToast('warning', 'Debe crear un traslado.');
    }
    if (!this.permissionUpdatable) {
      return this.toastHandlerService.showToast('error', `El usuario no tiene permisos para anular traslados.
        Comuníquese con el administrador del sistema.`);
    }
    if (this.transferStoreWorkshopContract.swBlock) {
      return this.toastHandlerService.showToast('warning', `El traslado se encuentra actualmente bloqueado.
        Comuníquese con el administrador del sistema.`);
    }
    if (this.quantityDetails !== 0) {
      return this.toastHandlerService.showToast('warning', 'No se puede anular un traslado con detalle.');
    }
    const result = await Swal.fire({
      title: 'Atención',
      text: "¿Realmente desea anular el traslado?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        const response = await firstValueFrom(this.transferStoreWorkshopService.annulAsync(this.transferStoreWorkshopId));
        this.transferStoreWorkshopContract = response;
        this.validateForm(this.transferStoreWorkshopContract);
        this.toastHandlerService.showToast('success', 'El traslado se anuló exitosamente.');
      } catch (error) {
        console.error('Error al anular el traslado.', error);
      }
    }
  }

  async blockTransferStoreWorkshop(value: boolean) {
    if (!this.transferStoreWorkshopId) {
      return setTimeout(() => this.formTransferStoreWorkshop.controls["swBlock"].patchValue(!value));
    }
    if (this.transferStoreWorkshopContract.transferStoreWorkshopState == TransferStoreWorkshopStateEnums.open) {
      setTimeout(() => this.formTransferStoreWorkshop.controls["swBlock"].patchValue(!value));
      return this.toastHandlerService.showToast('warning', 'No es posible bloquear el traslado mientras se encuentre en estado abierto.');
    }
    try {
      const response = await firstValueFrom(this.transferStoreWorkshopService.blockAsync(this.transferStoreWorkshopId));
      this.transferStoreWorkshopContract = response;
      this.validateForm(this.transferStoreWorkshopContract);
    } catch (error) {
      console.error('Error al bloquear el traslado.', error);
    }
  }

  async changeBranch(branchId: number) {
    this.branchId = branchId;
    this.resetContract();
  }

  async changeConsecutive(consecutive: number) {
    this.branchId = this.formTransferStoreWorkshop.get("branchId")?.value;
    if (!this.branchId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
    }
    if (!consecutive) {
      this.resetContract();
      return;
    }
    try {
      const response = await firstValueFrom(this.transferStoreWorkshopService.getTransferStoreWorkshopByKeysAsync(this.branchId,
        consecutive));
      this.transferStoreWorkshopId = response.transferStoreWorkshopId;
      this.transferStoreWorkshopContract = response;
      this.validateForm(this.transferStoreWorkshopContract);
      this.location.replaceState(`/${this.url}/register/${this.transferStoreWorkshopId}`);
    } catch (error) {
      console.error('Error al buscar el traslado.', error);
    }
  }

  changeTransferStoreWorkshopType(currentType: number) {
    const previousType = this.transferStoreWorkshopContract.type;
    if ((currentType != previousType) && this.quantityDetails != 0) {
      setTimeout(() => this.formTransferStoreWorkshop.controls["type"].patchValue(previousType));
      this.toastHandlerService.showToast('warning', 'No puede cambiarse el tipo del traslado mientras tenga detalle.');
    }
  }

  async changeTransferStoreWorkshopState() {
    const { transferStoreWorkshopId, swBlock } = this.transferStoreWorkshopContract;
    if (!transferStoreWorkshopId) {
      this.toastHandlerService.showToast('warning', 'Debe crear un traslado.');
      return;
    }
    if (!this.permissionUpdatable) {
      return this.toastHandlerService.showToast('error', `No tiene permisos para cambiar el estado del traslado.
        Comuníquese con el administrador del sistema.`);
    }
    if (swBlock) {
      return this.toastHandlerService.showToast('warning', `El traslado se encuentra actualmente bloqueado.
        Comuníquese con el administrador del sistema.`);
    }
    if (this.hasQuantityInZero) {
      return this.toastHandlerService.showToast('warning', 'No puede cambiar el estado del traslado si tiene detalles con cantidades en cero.');
    }
    try {
      const response = await firstValueFrom(this.transferStoreWorkshopService.changeStateAsync(transferStoreWorkshopId));
      this.transferStoreWorkshopContract = response;
      this.validateForm(this.transferStoreWorkshopContract);
      const successMessage = response.transferStoreWorkshopState ? 'El traslado fue abierto exitosamente.'
        : 'El traslado fue abierto fue cerrado exitosamente.';
      this.toastHandlerService.showToast('success', successMessage);
    } catch (error) {
      console.error('Error al cambiar el estado de el traslado.', error);
    }
  }

  async createNewRegister() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para crear un traslado.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    this.resetContract();
  }

  async createTransferStoreWorkshop(modelTransferStoreWorkshop: TransferStoreWorkshopModel) {
    try {
      const response = await firstValueFrom(this.transferStoreWorkshopService.createAsync(modelTransferStoreWorkshop));
      this.transferStoreWorkshopId = response.transferStoreWorkshopId;
      this.transferStoreWorkshopContract = response;
      this.validateForm(this.transferStoreWorkshopContract);
      this.location.replaceState(`/${this.url}/register/${this.transferStoreWorkshopId}`);
      this.toastHandlerService.showToast('success', `El traslado fue creado exitosamente.`);
    } catch (error) {
      console.error('Error al crear el traslado.', error);
      setTimeout(() => this.formTransferStoreWorkshop.controls["consecutive"].patchValue(0));
    }
  }

  async deleteTransferStoreWorkshop() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para eliminar el traslado.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    if (!this.transferStoreWorkshopId) {
      this.toastHandlerService.showToast('warning', 'Debe crear un traslado.');
      return;
    }
    const result = await Swal.fire({
      title: 'Atención',
      text: '¿Realmente desea eliminar el traslado?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.transferStoreWorkshopService.deleteAsync(this.transferStoreWorkshopId));
        this.createNewRegister();
        this.toastHandlerService.showToast('success', 'El traslado fue eliminado exitosamente.');
      } catch (error) {
        console.error('Error al eliminar el traslado.', error);
      }
    }
  }

  finishLoading(finishPrint: boolean) {
    if (finishPrint) {
      window.print();
    }
  }

  async getAllLists() {
    try {
      const response = await firstValueFrom(this.branchService.getAllBranchesForSelectAsync());
      this.listBranches = response;
    } catch (error) {
      console.error('Error obtener las listas.', error);
    }
  }

  async getButtonClick(buttonClick: any) {
    this.branchId = this.formTransferStoreWorkshop.get("branchId")?.value;
    if (!this.branchId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
    }
    await this.handleTransferStoreWorkshopNavigation(buttonClick, this.branchId)
  }

  async getFirstBranchByUserAuthenticated() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      if (!response.branchId) {
        this.branchId = 0;
        return;
      }
      this.branchId = response.branchId;
    } catch (error) {
      this.branchId = 0;
      console.error('Error al obtener la sucursal principal del usuario.', error);
    }
  }

  async getPermission() {
    this.getUserAuthenticated();
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('error', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }
    await Promise.all([
      this.getAllLists(),
      this.getPermissionPrint(),
      this.getPermissionProfileByUrl(),
      this.getPermissionsForUserByWindow(),
    ]);
  }

  async getPermissionsForUserByWindow() {
    try {
      const response = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.TransferStoreWorkshop));
      this.permissionsUser = response;
    } catch (error) {
      console.error('Error al obtener los permisos del usuario.', error);
    }
  }

  async getPermissionPrint() {
    try {
      const response = await firstValueFrom(this.transferStoreWorkshopService.getPermissionPrintAsync());
      this.permissionPrint = response;
    } catch (error) {
      console.error('Error al buscar los permisos de impresión.', error);
    }
  }

  async getPermissionProfileByUrl() {
    try {
      const response = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      this.permissionUpdatable = response;
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getTransferStoreWorkshopById() {
    try {
      const response = await firstValueFrom(this.transferStoreWorkshopService.getByIdAsync(this.transferStoreWorkshopId));
      this.branchId = response.branchId;
      this.transferStoreWorkshopContract = response;
      this.validateForm(this.transferStoreWorkshopContract);
    } catch (error) {
      console.error('Error al obtener el traslado.', error);
    }
  }

  getUserAuthenticated() {
    const load = this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0))
      .subscribe(user => {
        this.userAuthenticated = user;
        this.companyId = user.companyId;
      });
    this.listObservers.push(load);
  }

  async handleInitialState() {
    if (this.transferStoreWorkshopId) {
      await this.getTransferStoreWorkshopById();
    } else {
      await this.getFirstBranchByUserAuthenticated();
      this.createNewRegister();
    }
  }

  async handleTransferStoreWorkshopNavigation(buttonClick: any, branchId: number) {
    const consecutive = this.formTransferStoreWorkshop.get("consecutive")?.value;
    const actionMap: Record<string, () => Promise<TransferStoreWorkshopModel>> = {
      first: () =>
        firstValueFrom(this.transferStoreWorkshopService.getFirstTransferStoreWorkshopByKeysAsync(branchId)),
      previus: () =>
        firstValueFrom(this.transferStoreWorkshopService.getPreviusTransferStoreWorkshopByKeysAsync(branchId, consecutive)),
      next: () =>
        firstValueFrom(this.transferStoreWorkshopService.getNextTransferStoreWorkshopByKeysAsync(branchId, consecutive)),
      last: () =>
        firstValueFrom(this.transferStoreWorkshopService.getLastTransferStoreWorkshopByKeysAsync(branchId)),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      this.resetContract();
      return;
    }
    try {
      const transferStoreWorkshop = await action();
      this.transferStoreWorkshopId = transferStoreWorkshop.transferStoreWorkshopId;
      this.transferStoreWorkshopContract = transferStoreWorkshop;
      this.validateForm(this.transferStoreWorkshopContract);
      this.location.replaceState(`/${this.url}/register/${this.transferStoreWorkshopId}`);
    } catch (error) {
      console.error(`Error al buscar el traslado (${buttonClick.target.id}).`, error);
    }
  }

  async onSave() {
    this.validateFormControls();
    if (!this.formTransferStoreWorkshop.valid) {
      this.showValidationMessages();
      return;
    }
    try {
      const response = await firstValueFrom(this.transferStoreWorkshopService.hasExistingTransferStoreWorkshop(this.branchId));
      if (!response) {
        this.initialConsecutiveModalComponent?.show();
        return;
      }
      await this.send();
    } catch (error) {
      console.error('Error al buscar el ultimo traslado.', error);
    }
  }

  async printPage() {
    if (!this.transferStoreWorkshopId) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un traslado.'
      );
      return;
    }
    if (!this.permissionPrint) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para imprimir traslados. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    this.toastHandlerService.clearAllToasts();
    try {
      const { branchId, transferStoreWorkshopId } = this.transferStoreWorkshopContract;
      const response = await firstValueFrom(this.transferStoreWorkshopService.getTransferStoreWorkshopByKeysByPrint(branchId, 0,
        transferStoreWorkshopId));
      this.transferStoreWorkshopPrintModel = response;
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      console.error('Error al imprimir el traslado.', error);
    }
  }

  async send() {
    this.validateFormControls();
    if (!this.formTransferStoreWorkshop.valid) {
      this.showValidationMessages();
      return;
    }
    const model = this.formTransferStoreWorkshop.getRawValue() as TransferStoreWorkshopModel;
    model.observation = model.observation?.trim() || null;

    if (this.transferStoreWorkshopId == 0) {
      await this.createTransferStoreWorkshop(model);
    } else {
      await this.updateTransferStoreWorkshop(model);
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'Debe seleccionar una Sucursal.',
        min: 'Debe seleccionar una Sucursal válida.'
      },
      transferStoreWorkshopState: {
        required: 'Debe seleccionar un Estado.',
        min: 'Debe seleccionar un Estado válido.'
      },
      dateTransferStoreWorkshop: {
        required: 'Debe seleccionar una Fecha.'
      },
      swBlock: {
        required: 'Debe seleccionar el Bloqueo.'
      },
      type: {
        required: 'Debe seleccionar un Tipo.',
        min: 'Debe seleccionar un Tipo válido.'
      },
      observation: {
        maxlength: 'La Observación no puede tener más de 250 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formTransferStoreWorkshop.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  async resetContract() {
    this.transferStoreWorkshopId = 0;
    this.transferStoreWorkshopContract = new TransferStoreWorkshopModel();
    this.transferStoreWorkshopContract.branchId = this.branchId;
    this.validateForm(this.transferStoreWorkshopContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async updateTransferStoreWorkshop(modelTransferStoreWorkshop: TransferStoreWorkshopModel) {
    this.transferStoreWorkshopContract.alterNumber = modelTransferStoreWorkshop.alterNumber;
    this.transferStoreWorkshopContract.type = modelTransferStoreWorkshop.type;
    this.transferStoreWorkshopContract.dateTransferStoreWorkshop = modelTransferStoreWorkshop.dateTransferStoreWorkshop;
    this.transferStoreWorkshopContract.observation = modelTransferStoreWorkshop.observation;
    try {
      const response = await firstValueFrom(this.transferStoreWorkshopService.updateAsync(this.transferStoreWorkshopContract));
      this.transferStoreWorkshopContract = response;
      this.validateForm(this.transferStoreWorkshopContract);
      this.toastHandlerService.showToast('success', `El traslado fue modificado exitosamente.`);
    } catch (error) {
      console.error('Error al modificar el traslado.', error);
    }
  }

  updateFormState(): void {
    const stateConfig: any = {
      [TransferStoreWorkshopStateEnums.open]: {
        icon: 'pi pi-lock-open',
        title: 'Cerrar',
        text: 'Abierta',
        isDisabled: false,
        severityState: 'danger',
        enableConsecutive: this.transferStoreWorkshopId !== 0
      },
      [TransferStoreWorkshopStateEnums.close]: {
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Cerrada',
        isDisabled: true,
        severityState: 'success',
        enableConsecutive: true
      },
      [TransferStoreWorkshopStateEnums.annulled]: {
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Anulado',
        isDisabled: true,
        severityState: 'warn',
        enableConsecutive: true
      },
      [TransferStoreWorkshopStateEnums.printed]: {
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Impreso',
        isDisabled: true,
        severityState: 'success',
        enableConsecutive: true
      }
    };

    const currentState = this.transferStoreWorkshopContract.transferStoreWorkshopState;
    const config = stateConfig[currentState];
    if (!config) return;

    this.icon = config.icon;
    this.titleState = config.title;
    this.severityState = config.severityState;
    this.stateTransferStoreWorkshop = config.text;
    this.disabledForm = config.isDisabled || this.transferStoreWorkshopContract.swBlock;

    const form = this.formTransferStoreWorkshop;

    if (!this.permissionUpdatable || this.transferStoreWorkshopContract.swBlock || config.isDisabled) {
      form.disable();
    } else {
      form.enable();
    }

    const consecutiveControl = form.controls['consecutive'];
    config.enableConsecutive ? consecutiveControl.enable() : consecutiveControl.disable();

    form.controls['swBlock'].enable();
    form.controls['branchId'].enable();
  }

  validateForm(transferStoreWorkshop: TransferStoreWorkshopModel) {
    this.formTransferStoreWorkshop = this.formBuilder.group({
      branchId: [transferStoreWorkshop.branchId, [Validators.required, Validators.min(1)]],
      consecutive: [transferStoreWorkshop.consecutive],
      alterNumber: [transferStoreWorkshop.alterNumber],
      transferStoreWorkshopState: [transferStoreWorkshop.transferStoreWorkshopState, [Validators.required, Validators.min(1)]],
      dateTransferStoreWorkshop: [transferStoreWorkshop.dateTransferStoreWorkshop ?
        this.dateConverterService.convertUtcToLocalDate(transferStoreWorkshop.dateTransferStoreWorkshop) : null, [Validators.required]],
      swBlock: [transferStoreWorkshop.swBlock, [Validators.required]],
      type: [transferStoreWorkshop.type, [Validators.required, Validators.min(1)]],
      observation: [transferStoreWorkshop.observation, [Validators.max(250)]]
    });
    this.updateFormState();
  }

  validateFormControls() {
    Object.keys(this.formTransferStoreWorkshop.controls).forEach((key) => {
      const control = this.formTransferStoreWorkshop.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
